<template>
  <el-drawer
      :visible.sync="visible"
      @open="init"
      @close="cancle"
      direction="rtl"
      size="960px"
      :withHeader="false">
    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">为 "{{ value.name }}" 角色配置资源</h2>
        <div class="toolbar text-align-reverse">
          <el-button size="small" type="primary" @click="save" round><i class="fa fa-save"></i> 保存</el-button>
        </div>
      </div>
      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>

      <el-table class="list-table" :data="resTree" tooltip-effect="dark" ref="resTreeTable"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                @select="onRowSelect"
                @select-all="onSelectAll"
                style="width: 100%" border>
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column type="selection" width="55" prop="resIds"></el-table-column>
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="根菜单" width="200"></el-table-column>
        <el-table-column label="子菜单">
          <template slot-scope="scope">
            <el-checkbox-group v-model="scope.row.checkIds" size="mini" @click.stop="" @change="handleCheckedChange(scope.row)">
              <el-checkbox v-for="child in scope.row.childrens" :key="child.id" :label="child.id">{{ child.name }}</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-align-center margin-top-30">
        <el-button @click="save" type="primary" size="small" round><i class="fa fa-save"></i> 保存</el-button>
        <el-button @click="cancle" size="small" round><i class="fa fa-remove"></i> 取消</el-button>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import { tree } from '@api/system/resource'
import { allot, fetchResIds } from '@api/system/role'

export default {
  name: 'conf-res',
  props: {
    value: {
      type: Object,
      required: true // 必传
    },
    visible: false
  },
  data() {
    return {
      resTree: []
    }
  },
  methods: {
    init() {
      this.getResourceTree()
      this.fetchEcho()

    },
    getResourceTree() {
      tree().then(resp => {
        this.resTree = resp.data.result
        this.resTree.forEach(o => {
          this.$set(o, 'checkIds', [])
        })
      })
    },
    fetchEcho: function() {
      fetchResIds(this.value.id).then(resp => {
        let echoRes = resp.data.result
        let resIds = echoRes.map(r=>r.resourceId)

        this.resTree.forEach(row => {
          if(resIds.includes(row.id)){                //回显一级菜单
            this.$set(row, 'isChecked', true)
            this.$refs.resTreeTable.toggleRowSelection(row, true)

            row.childrens.forEach((item) => {         //回显子节点
              if(resIds.includes(item.id)){
                this.$set(item, 'isChecked', true)
                row.checkIds.push(item.id)
              }
            })
          }
        })
      })
    },
    onRowSelect: function(selection, row) {
      if (!row.isChecked) {
        this.$set(row, 'isChecked', true)
        this.$set(row, 'checkIds', row.childrens.map(o => {
          return o.id
        }))
        row.childrens.map((item) => {
          item.isChecked = true
        })
      } else {
        this.$set(row, 'isChecked', false)
        this.$set(row, 'checkIds', [])
        row.childrens.map((item) => {
          item.isChecked = false
        })
      }
    },
    handleCheckedChange(row, isChecked, even) {
      if (row.checkIds.length == 0) {
        this.$refs.resTreeTable.toggleRowSelection(row, false)
      }
      if (row.checkIds.length <= row.childrens.length) {
        this.$refs.resTreeTable.toggleRowSelection(row, true)
      }
    },
    onSelectAll(selection) {          // 全选
      if (selection.length > 0) {
        this.resTree.forEach(res => {
          this.$set(res, 'isChecked', true)
          this.$set(res, 'checkIds', res.childrens.map(o => {
            return o.id
          }))
        })
      } else {
        this.resTree.forEach(res => {
          this.$set(res, 'isChecked', false)
          this.$set(res, 'checkIds', [])
        })
      }
    },
    submitCallback(resp) {
      if (resp.status === 200) {
        this.$message.success(resp.data.message)
        this.$emit('done', false)
      }
    },
    cancle() {
      this.$emit('done', false)
    },
    save() {
      let perms = {}
      this.resTree.forEach(res => {
        if (res.isChecked) {
          perms[res.id] = '*'
          res.checkIds.forEach(s => perms[s] = '*')
        }
      })

      allot(this.value.id, perms).then(resp => {
        let user = this.$store.state.user.info
        this.$store.dispatch('generateRoutes', user.roles || [])
        this.$message.success(resp.data.message)
        this.$emit('done', true)
      })
    }
  }
}
</script>
